import React from "react";
import Icon from "@ant-design/icons";

const DarkModeSvg = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor">
    <path
      d="M19.3898 13.4355C19.2881 13.3426 19.1391 13.3244 19.0177 13.3885C15.5416 15.2321 11.2757 14.0058 9.30736 10.5965C7.33904 7.18715 8.40947 2.88017 11.7444 0.79111C11.8609 0.718226 11.9191 0.579702 11.8895 0.445568C11.8601 0.311215 11.7494 0.209791 11.6131 0.192448C9.45225 -0.0852586 7.31248 0.344364 5.42385 1.435C3.13941 2.75328 1.50522 4.88317 0.822474 7.43127C0.139732 9.97937 0.490104 12.6407 1.80927 14.9254C3.12821 17.2101 5.25788 18.8443 7.80598 19.527C8.65689 19.7549 9.5203 19.8677 10.3782 19.8677C12.0895 19.8677 13.7785 19.419 15.3001 18.5404C17.1883 17.4502 18.6306 15.8117 19.4706 13.8016C19.5237 13.6747 19.4912 13.5283 19.3898 13.4355Z"
    />
  </svg>
);

const DarkModeIcon = (props) => <Icon component={DarkModeSvg} {...props} />;

export default DarkModeIcon;
